module.exports = __webpack_public_path__ + "img/197.6cd4096e.svg";